<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Caricamento</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-progress-linear
                  indeterminate
                  color="primary darken-2"
                ></v-progress-linear>
              </v-card-text>
              
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import router from '../router'

import { store } from '../store';
import { getHeader, userInfoUrl, quotationsUrl } from '../config.js';

const axios = require('axios');

const responseSuccessHandler = response => {
    return response;
  };

  const responseErrorHandler = error => {
    console.log('interceptor');
    if (error.response.status === 401) {
      router.push({name:'Login'});
    }

    return Promise.reject(error);
  };

  axios.interceptors.response.use(
    response => responseSuccessHandler(response),
    error => responseErrorHandler(error)
  );

  export default {
    props: {
      source: String,
    },
    data: () => ({
    }),
    mounted () {
      
      console.log('eccomi');
      console.log('offersId', this.$route.params.offersId);
      console.log('tk', this.$route.params.tk);

      var header = getHeader();

      console.log(header);

      var auth = 'Bearer ' + this.$route.params.tk

      console.log(auth);

      axios.get(userInfoUrl, {
              headers: {
                'Accept' : header.Accept,
                'Authorization': auth
              }
            })
            .then((response) => {
                // handle success
                console.log(response.data);

                if(response.data){
                  
                  console.log('qui');
                  store.commit('setAuth', response.data);

                  header = getHeader();

                  console.log(header);

                  axios.get(quotationsUrl + '/quoteInfoByOffer/' + this.$route.params.offersId, {
                    headers: {
                      'Accept' : header.Accept,
                      'Authorization': header.Authorization
                    }
                  })
                  .then((response) => {
                      // handle success
                      console.log(response.data);

                      if(response.data.quotation.offer_id){
                        
                        router.push({ name: 'Quotation', params: { quotationId: response.data.quotation.id, offerId:  this.$route.params.offersId } });

                      }else{
                        
                        router.push({ name: 'Quotation', params: { quotationId: 0, offerId:  this.$route.params.offersId} });

                      }

                  })
                  .catch(function (error) {
                      // handle error
                      console.log(error);
                  });

                }else{
                  this.$fire({
                    title: "Errore!",
                    text: 'Impossibile autenticare l\'utente, errore nei dati',
                    type: "error",
                    timer: 5000
                  });
                }

            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });

    },
    methods: {
        
    }
  }
</script>